import { render } from "./TBox.vue?vue&type=template&id=43e3b680&scoped=true"
import script from "./TBox.vue?vue&type=script&lang=js"
export * from "./TBox.vue?vue&type=script&lang=js"

import "./TBox.vue?vue&type=style&index=0&id=43e3b680&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-43e3b680"]])

export default __exports__